import { StyleSheet } from 'aphrodite'

import main from './main'
import headers from './headers'
import form from './form'
import paragraphs from './paragraphs'
import buttons from './buttons'
import error from './error'

export default {
  main: StyleSheet.create(main),
  headers: StyleSheet.create(headers),
  form: StyleSheet.create(form),
  paragraphs: StyleSheet.create(paragraphs),
  buttons: StyleSheet.create(buttons),
  error: StyleSheet.create(error)
}



// WEBPACK FOOTER //
// ./src/components/Contact/style/index.js